import EbisApi from "../httpClients/EbisApi";

export const getEbisRoster = orgId => {
  if (orgId) {
    return EbisApi.getEbisRosterByOrgId(orgId);
  }
};
